import { TableColumn } from '../../../components/_EOS/GenericTable/types'
import { AsnDetailExtended } from '../types'
import { ProductOrigin } from '../../../interfaces/Producto/ProductOrigins'
import { formatExpirationDate } from '../../../utils/dateHelper'

export const getColumnsConfig = (
  productOrigins?: ProductOrigin[]
): TableColumn<AsnDetailExtended>[] => [
  {
    key: 'brandId' as keyof AsnDetailExtended,
    title: 'Marca',
    sortable: true,
    width: 150,
    cellStyle: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '150px'
    },
    render: (value: string | number | boolean | undefined) => {
      return (
        productOrigins?.find((el) => el.productOriginId === value)?.name ||
        'Sin Marca'
      )
    }
  },
  {
    key: 'asnId' as keyof AsnDetailExtended,
    title: 'ID ASN',
    sortable: true,
    render: (value: string | number | boolean | undefined) => value
  },
  {
    key: 'asnNumber' as keyof AsnDetailExtended,
    title: 'ASN',
    sortable: true,
    render: (value: string | number | boolean | undefined) => value
  },
  {
    key: 'lpn' as keyof AsnDetailExtended,
    title: 'LPN',
    sortable: true,
    render: (value: string | number | boolean | undefined) => value
  },
  {
    key: 'sku' as keyof AsnDetailExtended,
    title: 'SKU',
    sortable: true,
    width: 200,
    cellStyle: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '200px'
    },
    render: (value: string | number | boolean | undefined) => value
  },
  {
    key: 'batch' as keyof AsnDetailExtended,
    title: 'Lote',
    sortable: true,
    render: (value: string | number | boolean | undefined) => value || '-'
  },
  {
    key: 'expirationDate' as keyof AsnDetailExtended,
    title: 'Expiración',
    headerTooltip: 'Fecha de vencimiento',
    sortable: true,
    render: (value: string | number | boolean | undefined) =>
      formatExpirationDate(value as string, 'dd/MM/yyyy')
  },
  {
    key: 'realQty' as keyof AsnDetailExtended,
    title: 'A recepcionar',
    headerTooltip: 'Cantidad a recepcionar',
    sortable: true,
    align: 'center',
    render: (value: string | number | boolean | undefined) =>
      value == null ? 0 : value
  },
  {
    key: 'controlledQty' as keyof AsnDetailExtended,
    title: 'Controladas',
    sortable: true,
    align: 'center',
    render: (value: string | number | boolean | undefined) =>
      value == null ? 0 : value
  },
  {
    key: 'locatedQty' as keyof AsnDetailExtended,
    title: 'Ubicadas',
    sortable: true,
    align: 'center',
    render: (value: string | number | boolean | undefined) =>
      value == null ? 0 : value
  }
]
